import $axios from '~/plugins/axios';

import { Api, GetWarehouseParams, Warehouse } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetWarehouseParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		warehouseById: {} as Dict<Warehouse>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.warehouseById[id]),
		byId: (state) => (id: number) => state.warehouseById[id] ?? null,
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_WAREHOUSES (state, warehouses: Warehouse[]) {
			state.warehouseById = { ...state.warehouseById, ...createDict(warehouses, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...warehouses.map((warehouse) => warehouse.id) ]));
		},
		SET_WAREHOUSES (state, warehouses: Warehouse[]) {
			state.warehouseById = { ...state.warehouseById, ...createDict(warehouses, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetWarehouseParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/warehouse', { params });

			commit('APPEND_WAREHOUSES', data.payload);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});
